
import styled from "styled-components";
import MeasureIntro from "../components/Measure/MeasureIntro";
import WorkingAds from "../components/Measure/WorkingAds";
import OptimizeCampaigns from "../components/Measure/OptimizeCampaigns";
import ConnectTrackScale from "../components/Measure/ConnectTrackScale";
import GetStartedRequestDemoSide from "../components/generic/GetStartedRequestDemoSide";
import TrackingComponent from "../components/Tracking/TrackingComponent";
import { ReactComponent as GridAssetIcon } from "../assets/decorations/blueBannerGrid.svg";
import { lightThemeColors } from "../assets/style/colors";
import { Helmet } from "react-helmet-async";

const Measure = () => {

    return (
        <>
            {" "}
            <Helmet>
                <title>Grovs Measure | Stop Wasting Money on Ads That Don’t Work</title>
                <meta
                    name="description"
                    content="Take control of your ad performance with Grovs Measure. Gain accurate insights, reduce wasted spend, and scale your mobile marketing with confidence."
                />
                <meta
                    name="keywords"
                    content="ad performance, mobile attribution, ad tracking, ROI optimization, campaign analytics, Grovs Measure, app marketing, user re-engagement, campaign management"
                />
                <meta name="robots" content="index, follow" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Grovs Measure | Stop Wasting Money on Ads That Don’t Work"
                />
                <meta
                    property="og:description"
                    content="With Grovs, track ad performance across platforms, know what drives installs and reactivations, and grow your app without wasting budget. Try it free today."
                />
                <meta property="og:url" content="https://www.grovs.io/measure" />
                <meta
                    property="og:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="Grovs Measure | Optimize Ad Performance with Confidence"
                />
                <meta
                    name="twitter:description"
                    content="Stop guessing and start optimizing. Grovs Measure gives you real-time insights into what ads work—so you can cut waste and grow smarter."
                />
                <meta
                    name="twitter:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />
            </Helmet>
            <Container>
                <MeasureIntro />
                <WorkingAds />
                <OptimizeCampaigns />
                <ConnectTrackScale />
                <GetStartedRequestDemoSide
                    bgColor={lightThemeColors.measureBg}
                    gradientColor={"rgba(91, 104, 223, 1)"}
                    titleStyle={{ color: lightThemeColors.lightColor }}
                    subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
                    gridDecoration={<GridAssetIcon />}
                    primaryButtonStyle={{ color: lightThemeColors.lightColor }}
                    primaryButtonVariant={lightThemeColors.footerBg}
                    outlineButtonStyle={{
                        color: lightThemeColors.darkColor,
                        background: lightThemeColors.lightColor,
                    }}
                    outlineButtonVariant={lightThemeColors.lightColor}
                    title={
                        "Stop Wasting Money on Ads That Don’t Work—Optimize Your Ads Today!"
                    }
                    subtitle={
                        "Ready to take control of your ad spend and unlock real growth? Get the insights you need to optimize your ads, cut waste, and drive better results—faster."
                    }
                />
                <TrackingComponent />
            </Container>
        </>
    );
};

export default Measure;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
